// src/Sections/CalendarPage/CalendarPage.jsx
import React, { useState, useEffect } from "react";
import "./CalendarPage.css";
import api from '../../api';

export default function CalendarPage() {
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [calendarItems, setCalendarItems] = useState([]);
  const [viewMode, setViewMode] = useState("month"); // "month" or "week"

  // Fetch calendar items from backend
  useEffect(() => {
    fetchCalendarItems();
  }, []);

  const fetchCalendarItems = async () => {
    try {
      const res = await api.get('/calendar');
      const items = Array.isArray(res.data) ? res.data : [];
      console.log("📅 Calendar items fetched:", items);
      setCalendarItems(items);
    } catch (err) {
      console.error("Failed to fetch calendar items:", err);
    }
  };

      const renderCalendarDays = () => {
        if (viewMode === "week") {
          return renderWeekView();
        }
        return renderMonthView();
      };

      const renderWeekView = () => {
        const today = new Date(selectedMonth);
        const dayOfWeek = today.getDay();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - dayOfWeek); // Start from Sunday

        const week = [];
        for (let i = 0; i < 7; i++) {
          const date = new Date(startOfWeek);
          date.setDate(startOfWeek.getDate() + i);
          week.push(date);
        }

        // Find max items in any day for consistent height
        let maxItems = 0;
        week.forEach((date) => {
          const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
          const dayItems = calendarItems.filter((item) => {
            if (!item.post_date) return false;
            let itemFormatted;
            if (typeof item.post_date === 'string') {
              itemFormatted = item.post_date.split('T')[0];
            } else {
              const itemDate = new Date(item.post_date);
              itemFormatted = `${itemDate.getFullYear()}-${String(itemDate.getMonth() + 1).padStart(2, '0')}-${String(itemDate.getDate()).padStart(2, '0')}`;
            }
            return itemFormatted === formatted;
          });
          maxItems = Math.max(maxItems, dayItems.length);
        });

        return (
          <div className="calendar-week">
            {week.map((date, di) => {
              const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
              const dayItems = calendarItems.filter((item) => {
                if (!item.post_date) return false;
                let itemFormatted;
                if (typeof item.post_date === 'string') {
                  itemFormatted = item.post_date.split('T')[0];
                } else {
                  const itemDate = new Date(item.post_date);
                  itemFormatted = `${itemDate.getFullYear()}-${String(itemDate.getMonth() + 1).padStart(2, '0')}-${String(itemDate.getDate()).padStart(2, '0')}`;
                }
                return itemFormatted === formatted;
              });
              const isWeekend = date.getDay() === 0 || date.getDay() === 6;
              return (
                <div key={di} className={`calendar-day ${isWeekend ? 'weekend' : ''}`}>
                  <div className="day-number">{date.getDate()}</div>
                  <div className="calendar-items-container">
                    {dayItems.map((i) => (
                      <div
                        key={i.id}
                        className={`calendar-item ${
                          i.status === "Completed" ? "released" : "scheduled"
                        }`}
                      >
                        <span
                          className={`status-bubble ${
                            i.status === "Completed" ? "green" : "yellow"
                          }`}
                        ></span>
                        {i.title}
                      </div>
                    ))}
                    {/* Spacer divs to ensure consistent height */}
                    {Array.from({ length: maxItems - dayItems.length }).map((_, idx) => (
                      <div key={`spacer-${idx}`} className="calendar-item-spacer"></div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        );
      };

      const renderMonthView = () => {
        const year = selectedMonth.getFullYear();
        const month = selectedMonth.getMonth();
        const firstDay = new Date(year, month, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const weeks = [];
        let currentWeek = [];

        for (let i = 0; i < firstDay.getDay(); i++) currentWeek.push(null);

        for (let day = 1; day <= daysInMonth; day++) {
          currentWeek.push(new Date(year, month, day));
          if (currentWeek.length === 7) {
            weeks.push(currentWeek);
            currentWeek = [];
          }
        }
        if (currentWeek.length) weeks.push(currentWeek);

        // Find max items in any day across all weeks for consistent height
        let maxItems = 0;
        weeks.forEach((week) => {
          week.forEach((date) => {
            if (!date) return;
            const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            const dayItems = calendarItems.filter((item) => {
              if (!item.post_date) return false;
              let itemFormatted;
              if (typeof item.post_date === 'string') {
                itemFormatted = item.post_date.split('T')[0];
              } else {
                const itemDate = new Date(item.post_date);
                itemFormatted = `${itemDate.getFullYear()}-${String(itemDate.getMonth() + 1).padStart(2, '0')}-${String(itemDate.getDate()).padStart(2, '0')}`;
              }
              return itemFormatted === formatted;
            });
            maxItems = Math.max(maxItems, dayItems.length);
          });
        });

        return weeks.map((week, wi) => (
          <div key={wi} className="calendar-week">
            {week.map((date, di) => {
              if (!date) return <div key={di} className="calendar-day empty"></div>;
              const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
              const dayItems = calendarItems.filter((item) => {
                if (!item.post_date) return false;
                let itemFormatted;
                if (typeof item.post_date === 'string') {
                  itemFormatted = item.post_date.split('T')[0];
                } else {
                  const itemDate = new Date(item.post_date);
                  itemFormatted = `${itemDate.getFullYear()}-${String(itemDate.getMonth() + 1).padStart(2, '0')}-${String(itemDate.getDate()).padStart(2, '0')}`;
                }
                return itemFormatted === formatted;
              });
              const isWeekend = date.getDay() === 0 || date.getDay() === 6;
              return (
                <div key={di} className={`calendar-day ${isWeekend ? 'weekend' : ''}`}>
                  <div className="day-number">{date.getDate()}</div>
                  <div className="calendar-items-container">
                    {dayItems.map((i) => (
                      <div
                        key={i.id}
                        className={`calendar-item ${
                          i.status === "Completed" ? "released" : "scheduled"
                        }`}
                      >
                        <span
                          className={`status-bubble ${
                            i.status === "Completed" ? "green" : "yellow"
                          }`}
                        ></span>
                        {i.title}
                      </div>
                    ))}
                    {/* Spacer divs to ensure consistent height */}
                    {Array.from({ length: maxItems - dayItems.length }).map((_, idx) => (
                      <div key={`spacer-${idx}`} className="calendar-item-spacer"></div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ));
      };

      return (
        <div className="calendar-section">
          <h2>Release Calendar</h2>

          <div className="calendar-controls">
            <div className="view-toggle">
              <button
                className={viewMode === "month" ? "active" : ""}
                onClick={() => setViewMode("month")}
              >
                Month
              </button>
              <button
                className={viewMode === "week" ? "active" : ""}
                onClick={() => setViewMode("week")}
              >
                Week
              </button>
            </div>
            <div className="navigation-controls">
              <button
                onClick={() => {
                  if (viewMode === "week") {
                    const newDate = new Date(selectedMonth);
                    newDate.setDate(newDate.getDate() - 7);
                    setSelectedMonth(newDate);
                  } else {
                    setSelectedMonth(
                      new Date(
                        selectedMonth.getFullYear(),
                        selectedMonth.getMonth() - 1,
                        1
                      )
                    );
                  }
                }}
              >
                ←
              </button>
              <span>
                {viewMode === "week" ? (
                  <>
                    {selectedMonth.toLocaleDateString("default", {
                      month: "short",
                      day: "numeric",
                    })}{" "}
                    -{" "}
                    {(() => {
                      const endOfWeek = new Date(selectedMonth);
                      endOfWeek.setDate(selectedMonth.getDate() + (6 - selectedMonth.getDay()));
                      return endOfWeek.toLocaleDateString("default", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      });
                    })()}
                  </>
                ) : (
                  <>
                    {selectedMonth.toLocaleString("default", { month: "long" })}{" "}
                    {selectedMonth.getFullYear()}
                  </>
                )}
              </span>
              <button
                onClick={() => {
                  if (viewMode === "week") {
                    const newDate = new Date(selectedMonth);
                    newDate.setDate(newDate.getDate() + 7);
                    setSelectedMonth(newDate);
                  } else {
                    setSelectedMonth(
                      new Date(
                        selectedMonth.getFullYear(),
                        selectedMonth.getMonth() + 1,
                        1
                      )
                    );
                  }
                }}
              >
                →
              </button>
            </div>
          </div>

          <div className="calendar-grid">{renderCalendarDays()}</div>
        </div>
      );
}
